import { useWSStore } from "../../store";
import { useQueryCMSWebflowEnterprise } from "../cms/queries";
import { useUserId } from "../hooks/helpers";
import { useQueryActivities } from "../users/queries";
import { getCurrentEntepriseId } from "./selectors";

export const useQueryEnterprise = () => {
  const userId = useUserId();
  const activityQuery = useQueryActivities(userId);
  const store = useWSStore();
  const enterpriseId = getCurrentEntepriseId(store, activityQuery.data);
  return useQueryCMSWebflowEnterprise(enterpriseId || "", {
    enabled: !!enterpriseId
  });
};
